import { db } from "astrid-firebase";
import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import { useProfile } from "../../../../authentication/state/profile";

export default function useMyProductionsQuery({ organization }) {
	const profile = useProfile();

	const query = db.collection("productions").where("deleted", "==", false).where("status", "!=", "done");

	if (!organization) {
		return query.where("teamUserIds", "array-contains", profile.id);
	}

	if (profile) {
		switch (organization.type) {
			case organizationTypes.PUBLISHER:
				return query
					.where("publisher", "==", organization.id)
					.where("publisherManagerIds", "array-contains", profile.id);

			case organizationTypes.PRODUCER:
				return query
					.where("producer", "==", organization.id)
					.where("teamUserIds", "array-contains", profile.id);

			case organizationTypes.NARRATOR:
				return query.where("teamUserIds", "array-contains", profile.id);

			default:
				return null;
		}
	}

	return null;
}
